import { createSlice } from "@reduxjs/toolkit";
import { fetchAiSearchParts } from "./aiAssistantAction";

const initialState = {
  searchResults: [],
  searchLoading: false,
  error: null,
  isChatOpen: false,
  messages: [],
  currentQuery: null,
  aiResponse: null
};

const aiAssistantSlice = createSlice({
  name: "aiAssistant",
  initialState,
  reducers: {
    openChat: (state) => {
      state.isChatOpen = true;
      if (state.messages.length === 0) {
        state.messages.push({
          id: Date.now(),
          sender: "assistant",
          type: "text",
          text: "Hello! I'm Kato, your PartsLokator AI assistant. I can help you quickly locate the right auto parts—just write your query.\n\nHow may I assist you today?",
          timestamp: new Date().toISOString()
        });
      }
    },
    closeChat: (state) => {
      state.isChatOpen = false;
    },
    addMessage: (state, action) => {
      state.messages.push({
        id: Date.now() + Math.random(),
        timestamp: new Date().toISOString(),
        ...action.payload
      });
    },
    clearMessages: (state) => {
      state.messages = [];
    },
    clearError: (state) => {
      state.error = null;
    },
    setCurrentQuery: (state, action) => {
      state.currentQuery = action.payload;
    },
    setAiResponse: (state, action) => {
      state.aiResponse = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAiSearchParts.pending, (state) => {
        state.searchLoading = true;
        state.error = null;
      })
      .addCase(fetchAiSearchParts.fulfilled, (state, action) => {
        state.searchLoading = false;
        state.searchResults = action.payload.results || [];
        state.aiResponse = action.payload.aiResponse;
        state.currentQuery = action.payload.query;
      })
      .addCase(fetchAiSearchParts.rejected, (state, action) => {
        state.searchLoading = false;
        state.error = action.payload;
      });
  }
});

export const {
  openChat,
  closeChat,
  addMessage,
  clearMessages,
  clearError,
  setCurrentQuery,
  setAiResponse
} = aiAssistantSlice.actions;

export default aiAssistantSlice.reducer;
